var BLOCK_NUMBER = "0xFB0A000000000000000000000000000000000000";
var L1_BLOCK_NUMBER = "0xFBAA000000000000000000000000000000000000";
var BLOCK_TIMESTAMP = "0xFB0B000000000000000000000000000000000000";
var GAS_PRICE = "0xFB0C000000000000000000000000000000000000";
var MINER_ADDRESS = "0xFA0A000000000000000000000000000000000000";
var ORIGIN_ADDRESS = "0xFA0B000000000000000000000000000000000000";
var INVESTOR_ADDRESS = "0xFA0C000000000000000000000000000000000000";
var ACTIVATOR_ADDRESS = "0xFA0D000000000000000000000000000000000000";
var ENGINE_ADDRESS = "0xFA0E000000000000000000000000000000000000";
var CHAIN_ID = "0xFB0E000000000000000000000000000000000000";
var FLOW_HASH = "0xFB0D000000000000000000000000000000000000";
var RANDOM_NUMBER = "0xFB08000000000000000000000000000000000000";
var FCT_MAX_GAS_PRICE = "0xFB09000000000000000000000000000000000000";
// const BLOCK_HASH = "0xFF00000000000000000000000000000000000000";
export var globalVariables = {
    blockNumber: BLOCK_NUMBER,
    blockTimestamp: BLOCK_TIMESTAMP,
    chainId: CHAIN_ID,
    gasPrice: GAS_PRICE,
    minerAddress: MINER_ADDRESS,
    originAddress: ORIGIN_ADDRESS,
    investorAddress: INVESTOR_ADDRESS,
    activatorAddress: ACTIVATOR_ADDRESS,
    engineAddress: ENGINE_ADDRESS,
    flowHash: FLOW_HASH,
    randomNumber: RANDOM_NUMBER,
    fctMaxGasPrice: FCT_MAX_GAS_PRICE,
    l1BlockNumber: L1_BLOCK_NUMBER,
    fctMaxRepeats: '',
    fctRepeatsLeft: '',
};
export var globalVariablesBytes = {
    blockNumber: BLOCK_NUMBER.padEnd(66, "0"),
    blockTimestamp: BLOCK_TIMESTAMP.padEnd(66, "0"),
    chainId: CHAIN_ID.padEnd(66, "0"),
    gasPrice: GAS_PRICE.padEnd(66, "0"),
    flowHash: FLOW_HASH.padEnd(66, "0"),
    randomNumber: RANDOM_NUMBER.padEnd(66, "0"),
    fctMaxGasPrice: FCT_MAX_GAS_PRICE.padEnd(66, "0"),
    l1BlockNumber: L1_BLOCK_NUMBER.padEnd(66, "0"),
    fctMaxRepeats: '0x1',
    fctRepeatsLeft: '0x1',
};
